<template>
  <!-- 任务明细 -->
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="24">
          <a-col :md="6" :sm="12">
            <a-form-item label="任务名称">
              <a-input v-model="query.taskName" placeholder="请输入任务名称" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="12">
            <a-form-item label="抄表员">
              <a-select placeholder="请选择" v-model="query.readerId" allow-clear>
                <a-select-option v-for="item in meterReaderList" :key="item.id" :value="item.id">
                  {{ item.readerName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="12">
            <a-form-item label="任务状态">
              <a-select placeholder="请选择" v-model="query.taskStatus" allow-clear>
                <a-select-option value>全部</a-select-option>
                <a-select-option :value="0">待抄表</a-select-option>
                <a-select-option :value="1">抄表中</a-select-option>
                <a-select-option :value="2">已完成</a-select-option>
                <a-select-option :value="3">已逾期</a-select-option>

              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="12">
            <a-form-item label="表册分组">
              <a-select placeholder="请选择" v-model="query.groupId" allow-clear @change="onQueryGroupChange">
                <a-select-option v-for="item in bookGroupList" :key="item.id" :value="item.id">
                  {{ item.groupName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="12">
            <a-form-item label="表册">
              <a-select 
                placeholder="请选择" 
                v-model="query.bookId" 
                allow-clear 
                show-search
                :filter-option="filterMeterBookOption"
                :disabled="!query.groupId"
              >
                <a-select-option v-if="!query.groupId" disabled value=""> 请先选择表册分组 </a-select-option>
                <a-select-option v-for="item in meterBooksList" :key="item.id" :value="item.id">
                  {{ item.bookName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="16">
            <a-form-item>
              <a-button type="primary" icon="search" @click="queryList">查询</a-button>
              <a-button style="margin-left: 8px" icon="reload" @click="resetList">重置</a-button>
              <a-button type="danger" style="margin-left: 8px" icon="delete" @click="deleteSelectRow()" v-action:del
                >批量删除</a-button
              >
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-table
      size="middle"
      rowKey="id"
      bordered
      :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
      :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
      :data-source="list"
      :columns="columns"
      :loading="dataListLoading"
      :pagination="pagination"
      :scroll="{ x: 1500 }"
      @change="pageChange"
    >
      <span slot="taskStatus" slot-scope="text">
        <a-tag class="status-tag" :color="getStatusColor(getStatusText(text))"> {{ getStatusText(text) }}</a-tag>
      </span>
      <span slot="taskProgress" slot-scope="text">
        <a-progress
          :percent="Number(text) || 0"
          :stroke-color="text >= 100 ? '#52c41a' : text >= 50 ? '#1890ff' : '#ff4d4f'"
          :show-info="false"
          size="small"
        />
        <span style="margin-left: 8px; font-size: 12px">{{ formatProgress(text) }}</span>
      </span>
      <span slot="action" slot-scope="text, record">
        <div class="action-container">
          <a @click="handleTaskProgress(record)" >任务进度</a>
          <a-divider type="vertical" />
          <a @click="handleViewTrajectory(record)" >查看轨迹</a>
          <a-divider v-if="record.taskStatus === 0 || record.taskStatus === 3" type="vertical" />
          <a v-if="record.taskStatus === 0 || record.taskStatus === 3" @click="deleteSingleTask(record)" v-action:del style="color: #ff4d4f"
            >删除</a
          >
        </div>
      </span>
    </a-table>
    <!-- 任务进度模态框 -->
    <a-modal
      title="任务进度详情"
      :visible="taskProgressVisible"
      :width="1700"
      :footer="null"
      @cancel="closeTaskProgress"
      :destroyOnClose="true"
      :bodyStyle="{ padding: '0', maxHeight: '80vh', overflowY: 'auto' }"
    >
      <TaskProgress
        v-if="taskProgressVisible"
        ref="taskProgress"
        :taskId="currentTaskId"
        @close="closeTaskProgress"
      />
    </a-modal>

    <!-- 轨迹模态框 -->
    <a-modal
      title="抄表轨迹"
      :visible="trajectoryVisible"
      :width="1200"
      :footer="null"
      @cancel="closeTrajectory"
      :destroyOnClose="true"
      :bodyStyle="{ padding: '20px' }"
    >
      <div v-if="trajectoryLoading" style="text-align: center; padding: 40px">
        <a-spin size="large" />
        <div style="margin-top: 16px">加载轨迹数据中...</div>
      </div>

      <div v-else-if="trajectoryData.length === 0" style="text-align: center; padding: 40px">
        <a-empty description="暂无轨迹数据" />
      </div>

      <div v-else> 
        <!-- 轨迹地图容器 -->
        <MapComponent 
          v-if="trajectoryVisible"
          :path="trajectoryPathData" 
          :taskInfo="currentTaskInfo"
          :meterReadingTaskDetails="meterReadingTaskDetails"
          ref="mapComponent"
        />  </div>
    </a-modal>
  </a-card>
</template>

<script>
import dayjs from 'dayjs'
import mixinViewModule from '@/mixin/common'
import { PERMISSION_ENUM } from '@/core/permission/permission'
import TaskProgress from './taskProgress.vue'
import MapComponent from './components/map.vue'

const STATUS = {
  1: '正常',
  2: '禁用',
}

const readingCycleMap = {
  1: '每月抄表',
  2: '单月抄表',
  3: '双月抄表',
}

// 轨迹表格列定义
const trajectoryColumns = [
  { title: '时间', dataIndex: 'timestamp', key: 'timestamp', width: 180, scopedSlots: { customRender: 'timestamp' } },
  { title: '经度', dataIndex: 'longitude', key: 'longitude', width: 120 },
  { title: '纬度', dataIndex: 'latitude', key: 'latitude', width: 120 },
  // { title: '海拔', dataIndex: 'altitude', key: 'altitude', width: 100, scopedSlots: { customRender: 'altitude' } },
  // { title: '速度', dataIndex: 'speed', key: 'speed', width: 100, scopedSlots: { customRender: 'speed' } },
  // { title: '方向', dataIndex: 'direction', key: 'direction', width: 100, scopedSlots: { customRender: 'direction' } },
]

const columns = [
  { title: '任务编号', dataIndex: 'taskNumber', key: 'taskNumber', width: 120 },
  { title: '任务名称', dataIndex: 'taskName', key: 'taskName', width: 150 },
  { title: '表册分组', dataIndex: 'groupName', key: 'groupName', width: 120 },
  { title: '抄表表册', dataIndex: 'bookName', key: 'bookName', width: 120 },
  { title: '抄表员', dataIndex: 'readerName', key: 'readerName', width: 100 },
  {
    title: '抄表周期',
    dataIndex: 'readingCycle',
    key: 'readingCycle',
    width: 100,
    customRender: (text) => readingCycleMap[text] || text,
  },
  { title: '抄表开始日期', dataIndex: 'startTime', key: 'startTime', width: 120 },
  { title: '抄表结束日期', dataIndex: 'endTime', key: 'endTime', width: 120 },
  { title: '应抄户数', dataIndex: 'shouldReadCount', key: 'shouldReadCount', width: 100 },
  { title: '已抄户数', dataIndex: 'alreadyReadCount', key: 'alreadyReadCount', width: 100 },
  { title: '未抄户数', dataIndex: 'notReadCount', key: 'notReadCount', width: 100 },
  { title: '已抄水量（m³）', dataIndex: 'alreadyReadWaterAmount', key: 'alreadyReadWaterAmount', width: 120 },
  {
    title: '任务状态',
    dataIndex: 'taskStatus',
    key: 'taskStatus',
    width: 100,
    scopedSlots: { customRender: 'taskStatus' },
  },
  {
    title: '抄表进度',
    dataIndex: 'taskProgress',
    key: 'taskProgress',
    width: 120,
    scopedSlots: { customRender: 'taskProgress' },
  },
  {
    title: '操作',
    width: 230,
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' },
    key: 'action',
    fixed: 'right',
  },
]

export default {
  components: {
    dayjs,
    TaskProgress,
    MapComponent,
  },
  mixins: [mixinViewModule],
  name: 'Task',
  data() {
    return {
      isMonth: false,
      dayjs,
      importLoading: false,
      visibles: false,
      endOpen: false,
      disabled: false,
      fileList: [],
      queryUrl: '/meter-manager/meter_tasks/page',
      deleteUrl: '/meter-manager/meter_tasks/batch',
      staffTreeData: [], // 分区数据选项
      bookTreeData: [], // 表册列表
      query: {
        surfaceBookNo: '',
        taskName: '',
        taskStatus: '',
        tenantId: this.$store.state.user.info.tenantId,
        readerId: '',
        groupId: '',
        bookId: '',
      },
      engineeringProjectEstab: {
        name: '',
        readingCycle: '',
        cycleCount: '',
        startValue: '',
        endValue: '',
        taskStatus: 0,
        state: 0,
        dataType: '',
        bookId: '',
        bookGroup: '',
        staffId: '',
        endTime: '',
        startTime: '',
      },
      addOrUpdateForm: this.$form.createForm(this, { name: 'addOrUpdate' }),
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      columns,
      trajectoryColumns, // 轨迹表格列定义
      meterReaderList: [], // 抄表员列表
      bookGroupList: [], // 表册分组列表
      meterBooksList: [], // 表册列表

      taskProgressVisible: false, // 控制任务进度模态框显示
      currentTaskId: '', // 当前选中的任务ID
      trajectoryVisible: false, // 控制轨迹模态框显示
      trajectoryData: [], // 轨迹数据
      trajectoryLoading: false, // 轨迹加载状态
      trajectoryMap: null, // 轨迹地图实例
      trajectoryPathData: [], // 轨迹路径数据，用于map组件
      currentTaskInfo: {}, // 当前任务信息，用于传递给map组件
      meterReadingTaskDetails: [], // 未获取到轨迹的抄表详情数据
    }
  },
 
  created() { 
    this.getMeterReaderData()
    this.getBookGroupData()
  },
  methods: {
    getStatusColor(text) {
      const colorMap = {
        待抄表: '#f93a3a',
        抄表中: '#ffa031',
        已完成: '#0cd51d',
        已逾期: '#d9d9d9',
      }
      return colorMap[text] || '#d9d9d9'
    },
    // 状态映射函数
    getStatusText(status) {
      const statusMap = {
        0: '待抄表',
        1: '抄表中',
        2: '已完成',
        3: '已逾期',
      }
      return statusMap[status] || status
    },
    handleTaskProgress(record) { 
      // 显示任务进度模态框
      this.currentTaskId = record.id
      this.taskProgressVisible = true
      // 等待弹窗渲染完成后，强制子组件自适应尺寸
      this.$nextTick(() => {
        setTimeout(() => {
          if (this.$refs.taskProgress && this.$refs.taskProgress.forceResize) {
            this.$refs.taskProgress.forceResize()
          }
        }, 50)
      })
    },
    closeTaskProgress() {
      this.taskProgressVisible = false
      this.currentTaskId = ''
    },

    // 关闭轨迹模态框
    closeTrajectory() {
      this.trajectoryVisible = false
      this.currentTaskId = ''
      this.trajectoryData = []
      this.trajectoryPathData = []
      this.trajectoryLoading = false
      this.currentTaskInfo = {}
      this.meterReadingTaskDetails = []
      
      // 清理map组件
      if (this.$refs.mapComponent) {
        this.$refs.mapComponent.removeLayer('轨迹')
      }
    },

    // 获取轨迹数据
    async fetchTrajectoryData(taskId) {
      this.trajectoryLoading = true
      try {
        const response = await this.$http.get(`/meter-manager/trajectory/task/${taskId}`)
        if (response.code === 0 && response.data) {
          // 新返回格式：TrajectoryTaskIdVo，包含 trajectoryList 和 meterReadingTaskDetails
          const data = response.data
          this.trajectoryData = data.trajectoryList || []
          this.meterReadingTaskDetails = data.meterReadingTaskDetails || []
          
          // 转换数据格式为map组件需要的格式
          this.convertTrajectoryDataForMap()
          
        } else {
          this.$message.error(response.message || '获取轨迹数据失败1')
          this.trajectoryData = []
          this.trajectoryPathData = []
          this.meterReadingTaskDetails = []
        }
      } catch (error) {
        this.$message.error('获取轨迹数据失败2')
        this.trajectoryData = []
        this.trajectoryPathData = []
        this.meterReadingTaskDetails = []
      } finally {
        this.trajectoryLoading = false
      }
    },

    // 计算总距离
    calculateTotalDistance() {
      if (this.trajectoryData.length < 2) return '0.00'

      let totalDistance = 0
      for (let i = 1; i < this.trajectoryData.length; i++) {
        const prev = this.trajectoryData[i - 1]
        const curr = this.trajectoryData[i]

        if (prev.longitude && prev.latitude && curr.longitude && curr.latitude) {
          const distance = this.calculateDistance(prev.latitude, prev.longitude, curr.latitude, curr.longitude)
          totalDistance += distance
        }
      }

      return totalDistance.toFixed(2)
    },

    // 计算两点间距离（公里）
    calculateDistance(lat1, lng1, lat2, lng2) {
      const R = 6371 // 地球半径（公里）
      const dLat = this.deg2rad(lat2 - lat1)
      const dLng = this.deg2rad(lng2 - lng1)
      const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(this.deg2rad(lat1)) * Math.cos(this.deg2rad(lat2)) * Math.sin(dLng / 2) * Math.sin(dLng / 2)
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
      return R * c
    },

    // 角度转弧度
    deg2rad(deg) {
      return deg * (Math.PI / 180)
    },

    // 计算平均速度
    calculateAverageSpeed() {
      const speeds = this.trajectoryData.map((point) => point.speed).filter((speed) => speed != null && speed > 0)

      if (speeds.length === 0) return '0.00'

      const avgSpeed = speeds.reduce((sum, speed) => sum + speed, 0) / speeds.length
      return avgSpeed.toFixed(2)
    },

    // 计算总时长
    calculateTotalTime() {
      if (this.trajectoryData.length < 2) return '0分钟'

      const firstPoint = this.trajectoryData[0]
      const lastPoint = this.trajectoryData[this.trajectoryData.length - 1]

      if (!firstPoint.timestamp || !lastPoint.timestamp) return '0分钟'

      const startTime = new Date(firstPoint.timestamp)
      const endTime = new Date(lastPoint.timestamp)
      const diffMs = endTime - startTime
      const diffMinutes = Math.floor(diffMs / (1000 * 60))

      if (diffMinutes < 60) {
        return `${diffMinutes}分钟`
      } else {
        const hours = Math.floor(diffMinutes / 60)
        const minutes = diffMinutes % 60
        return `${hours}小时${minutes}分钟`
      }
    },

    // 格式化时间戳
    formatTimestamp(timestamp) {
      if (!timestamp) return '-'
      return new Date(timestamp).toLocaleString('zh-CN')
    },

    // 单个删除任务
    deleteSingleTask(record) {
      // 允许删除待抄表(0)和已逾期(3)状态的任务
      if (record.taskStatus !== 0 && record.taskStatus !== 3) {
        this.$message.warning('只能删除待抄表或已逾期状态的任务')
        return
      }

      this.$confirm({
        title: '删除提醒',
        content: `您确认要删除任务"${record.taskName}"吗?`,
        okText: '确认',
        okType: 'danger',
        cancelText: '取消',
        onOk: async () => {
          try {
            const res = await this.$http.delete(`/meter-manager/meter_tasks/${record.id}`)
            if (res.code === 0) {
              this.$message.success('删除成功')
              this.queryList()
            } else {
              this.$message.error(res.message || '删除失败')
            }
          } catch (error) {
            console.error('删除失败:', error)
            this.$message.error('删除失败')
          }
        },
        onCancel: () => {
          this.$message.info('已取消删除')
        },
      })
    },

    handleViewTrajectory(record) {

      // 显示轨迹模态框
      this.currentTaskId = record.id
      this.trajectoryVisible = true
      
      // 设置当前任务信息
      this.currentTaskInfo = {
        bookName: record.bookName || '--',
        readerName: record.readerName || '--',
        alreadyReadCount: record.alreadyReadCount || '--',
        taskProgress: record.taskProgress || '--'
      }

      // 获取轨迹数据
      this.fetchTrajectoryData(record.id)
    },

    getMeterReaderData() {
      this.$http.get('/meter-manager/meter_readers/list').then(({ data }) => {
        this.meterReaderList = data
      })
    },

    getBookGroupData() {
      this.$http.get('/meter-manager/meter_book_groups/list').then(({ data }) => {
        this.bookGroupList = data || []
      })
    },

    getMeterBooksData(groupId = null) {
      if (!groupId) {
        this.meterBooksList = []
        return
      }
      this.$http
        .get(`/meter-manager/meter_reading_plans/meter-books?groupId=${groupId}`)
        .then(({ data }) => {
          this.meterBooksList = Array.isArray(data) ? data : data.list || data.data || []
        })
        .catch(() => {
          this.meterBooksList = []
        })
    },

    onQueryGroupChange() {
      this.query.bookId = ''
      if (this.query.groupId) {
        this.getMeterBooksData(this.query.groupId)
      } else {
        this.meterBooksList = []
      }
    },



    // 优化重置方法
    resetList() {
      this.query = {
        surfaceBookNo: '',
        taskName: '',
        taskStatus: '',
        tenantId: this.$store.state.user.info.tenantId,
        readerId: '',
        groupId: '',
        bookId: '',
      }
      this.pagination.current = 1
      this.selectedRows = []
      this.queryList()
    },

    // 格式化进度显示
    formatProgress(progress) {
      if (progress === null || progress === undefined) return '0%'
      return `${Math.round(progress)}%`
    },

    // 检查是否可以删除
    canDelete(record) {
      // 允许删除待抄表(0)和已逾期(3)状态的任务
      return record.taskStatus === 0 || record.taskStatus === 3
    },

    // 转换轨迹数据为map组件需要的格式
    convertTrajectoryDataForMap() {      
      if (this.trajectoryData.length === 0) {
        console.log('轨迹数据为空')
        this.trajectoryPathData = []
        return
      }

      // 过滤有效的坐标点并按时间戳排序
      const validPoints = this.trajectoryData
        .filter(point => point.longitude != null && point.latitude != null)
        .sort((a, b) => {
          const timeA = new Date(a.timestamp || 0).getTime()
          const timeB = new Date(b.timestamp || 0).getTime()
          return timeA - timeB
        })
      

      if (validPoints.length === 0) {
        console.log('没有有效的坐标点')
        this.trajectoryPathData = []
        return
      }

      // 获取第一个和最后一个时间点（现在已经是按时间排序的）
      const firstPoint = validPoints[0]
      const lastPoint = validPoints[validPoints.length - 1]

      // 构建map组件需要的数据格式
      const pathData = {
        name: `任务${this.currentTaskId}轨迹`,
        taskName: `任务${this.currentTaskId}`,
        start: firstPoint.timestamp || new Date().toISOString(),
        end: lastPoint.timestamp || new Date().toISOString(),
        // 关键修改：将对象格式转换为 [lng, lat] 数组格式
        point: validPoints.map(point => [Number(point.longitude), Number(point.latitude)]),
        jsonVos: validPoints.map(point => ({
          longitude: Number(point.longitude),
          latitude: Number(point.latitude),
          altitude: point.altitude,
          speed: point.speed,
          direction: point.direction,
          timestamp: point.timestamp,
          isReading: point.isReading,
          userCode: point.userCode || '',
          userName: point.userName || '',
          currentReading: point.currentReading || '',
          currentUsage: point.currentUsage || '',
          waterUsageType: point.waterUsageType || '',
          currentReadingTime: point.currentReadingTime || '',
        }))
      } 

      this.trajectoryPathData = [pathData]
    },

    // 表册搜索过滤函数
    filterMeterBookOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
  },
  watch: {},
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}
.tenant-form {
  /deep/ .permission-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}
/deep/.ant-table-thead > tr > th > {
  text-align: center;
}

/deep/.ant-table-tbody > tr > td {
  text-align: center;
}

/deep/ .ant-modal-body {
  padding: 0 24px 24px 24px;
}

.prompt {
  width: 500px;
  height: 50px;
  background-color: #d4e3fc;
  border-radius: 10px;
  margin: 10px 25px 10px 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 15px;
}

.status-tag {
  width: 80px;
  text-align: center;
  font-weight: 500;
  border-radius: 4px;
  color: white !important;
}
.action-container {
  display: flex;
  align-items: center;
  gap: 8px;
}

.action-container > a {
  color: #1890ff;
  transition: color 0.3s;
}

.action-container > a:hover {
  color: #40a9ff;
}

.action-container > a[style*='color: #ff4d4f']:hover {
  color: #ff7875 !important;
}

.status-tag {
  width: 80px;
  text-align: center;
  font-weight: 500;
  border-radius: 4px;
  color: white !important;
}

.table-striped {
  background-color: #fafafa;
}

.table-page-search-wrapper {
  margin-bottom: 16px;
  padding: 16px;
  border-radius: 6px;
}

/* 轨迹相关样式 */
.trajectory-stats {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 16px;
}

.stat-item {
  text-align: center;
}

.stat-label {
  font-size: 12px;
  color: #666;
  margin-bottom: 4px;
}

.stat-value {
  font-size: 18px;
  font-weight: bold;
  color: #1890ff;
}

#trajectory-map {
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  overflow: hidden;
}
</style>
